<template>
  <div>
    <modal name="confirm" height="230">
      <div class="confirm-modal-head">
        <div class="confirm-modal-close">
          <a @click="$modal.hide('confirm')"> &times; </a>
        </div>
      </div>
      <div class="main-title-modal mb-4">
        <h3 class="px-1">Supprimer la tâche</h3>
      </div>
      <div class="row">
        <h4 class="px-4">Êtes-vous sûr de vouloir effectuer cette action ?</h4>
      </div>
      <div class="d-flex justify-content-end mt-2 px-3">
        <button class="yes" @click="deleteTask(1)">
          {{ $t("global.yes") }}
        </button>
        <button class="no" @click="deleteTask(0)">{{ $t("global.no") }}</button>
      </div>
    </modal>
  </div>
</template>
<script>
export default {
  methods: {
    deleteTask(flag) {
      this.$emit('delete', flag);
      this.$modal.hide('confirm');
    },
  },
};
</script>
<style lang="scss">
.confirm-modal-head {
  position: relative;
  min-height: 45px;
  height: 45px;
  overflow-y: auto;
  .confirm-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .main-title-modal {
    p {
      font-family: "SF-Pro-Text";
      color: #212529;
      font-size: 14px;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }
}
.yes {
  padding: 5px 22px;
  margin-right: 10px;
  border-radius: 3px;
  border: solid 1px #17c671;
  background-color: transparent !important;
  color: #17c671 !important;
  font-size: 18px;
}
.no {
  padding: 5px 22px;
  margin-right: 10px;
  border-radius: 3px;
  border: solid 1px #fc452d;
  background-color: transparent !important;
  color: #fc452d !important;
  font-size: 18px;
}
</style>
